import { withCloseAfterExited } from "@10duke/dukeui";
import { default as View, ViewUserModalProps } from "./view-user-modal-view";

const ViewUserModal = withCloseAfterExited<ViewUserModalProps>(View);
export default ViewUserModal;
